import { render, staticRenderFns } from "./regular.vue?vue&type=template&id=829f3f32&"
import script from "./regular.vue?vue&type=script&lang=js&"
export * from "./regular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports